<template lang="pug">
  div(class="recycle-correct-rate block--normal")
    div
      span(class="font--18") 回收正確率
      time-picker(:time="'2020-12'" :format="'yyyy'" :minView="'year'" :img="`${require('@/assets/icon/drop_down.svg')}`" @changeChartData ="changeChartData")
    div
      correct-rate-line-chart(:yearlyData="yearlyData")
</template>

<script>
import TimePicker from '@/components/TimePicker.vue'
import CorrectRateLineChart from '@/components/chart/CorrectRateLineChart.vue'
import { generateYearlyCorrectRate } from '@/utils/dataHandler.js'
import apis from '@/apis/api.js'

export default {
  name: 'recycle-correct-rate',
  components: {
    TimePicker,
    CorrectRateLineChart
  },
  data () {
    return {
      generateYearlyCorrectRate,
      yearlyData: {}
    }
  },
  created () {
    this.getYearlyData('2020')
  },
  methods: {
    async getYearlyData (time) {
      const { data } = await apis.getTotalStatistics(time)
      this.yearlyData = this.generateYearlyCorrectRate(time, data.correctRate)
    },
    changeChartData (time) {
      this.getYearlyData(time.slice(0, 4))
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/helper/variables.scss";

.recycle-correct-rate {
  display: flex;
  flex-direction: column;
  height: 100%;
  > div:nth-child(1) {
    text-align: left;
    display: flex;
    align-items: center;
    > span {
      margin-right: 10px;
    }
  }
  > div:nth-child(2) {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    .month-tick {
      display: flex;
      justify-content: space-between;
      margin: 0 5% 0 5%;
      font-size: 14px;
    }
  }
}
</style>
